import { render, staticRenderFns } from "./TotalMarksCell.vue?vue&type=template&id=88b012a6&"
import script from "./TotalMarksCell.vue?vue&type=script&lang=js&"
export * from "./TotalMarksCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports